import { ResolutionToday } from '../Colorizer/ResolutionToday';
import { type FilterEditorItemType } from './FilterEditorItem';
import { ResolutionConverter } from '../Colorizer/ResolutionConverter';
import { type API_DataType } from '../../types-telematics';

export function explodeValuesFromFilterItem(
    filterItem: FilterEditorItemType,
    resolutionConverter: ResolutionConverter,
    dataType: API_DataType,
    relativeMode: boolean,
    isDirty: boolean
) {
    let min = filterItem.min ?? 0;
    let max = filterItem.max ?? 10;

    let currentValue1: number | false = filterItem?.default_values[0] ?? false;
    let currentValue2: number | false = filterItem?.default_values[1] ?? false;

    if (dataType === 'time') {
        min = 0;
        max = 60 * 24 - 1;
        if (currentValue1 < min) currentValue1 = min;
        if (currentValue1 > max) currentValue1 = max;
        resolutionConverter.setResolution('time');
    }

    let mongoKey = Object.keys(filterItem.mongoCondition)[0];
    if (
        typeof mongoKey !== 'undefined' &&
        typeof filterItem.mongoCondition[mongoKey] !== 'undefined'
    ) {
        switch (mongoKey) {
            case '$gte':
            case '$gt': {
                if (ResolutionToday.isValidTodayString(filterItem.mongoCondition[mongoKey])) {
                    resolutionConverter.setResolution('today');
                    relativeMode = true;
                }
                currentValue1 = resolutionConverter.getNumber(filterItem.mongoCondition[mongoKey]);
                currentValue2 = false;
                break;
            }
            case '$lte':
            case '$lt': {
                console.log('createBetweenSlider, $lte, $lt', filterItem.mongoCondition[mongoKey]);
                if (ResolutionToday.isValidTodayString(filterItem.mongoCondition[mongoKey])) {
                    resolutionConverter.setResolution('today');
                    relativeMode = true;
                    console.log('createBetweenSlider, $lte, $lt, relativeMode', relativeMode);
                }
                currentValue1 = false;
                currentValue2 = resolutionConverter.getNumber(filterItem.mongoCondition[mongoKey]);
                console.log('createBetweenSlider, $lte, $lt, currentValue2', currentValue2);
                break;
            }
            default: {
                if (ResolutionToday.isValidTodayString(filterItem.mongoCondition[mongoKey][0])) {
                    resolutionConverter.setResolution('today');
                    relativeMode = true;
                }
                currentValue1 = resolutionConverter.getNumber(
                    filterItem.mongoCondition[mongoKey][0]
                );
                currentValue2 = resolutionConverter.getNumber(
                    filterItem.mongoCondition[mongoKey][1]
                );
            }
        }
    } else {
        isDirty = false;
        // currentValue1 = filterItem.default_values[0];
        // currentValue2 = filterItem.default_values[1];
    }

    return {
        min,
        max,
        currentValue1,
        currentValue2,
        relativeMode,
        isDirty,
    };
}
